export { default } from './ShipmentDetailsNotificationBanner'
export type { ShipmentDetailsNotificationBannerProps } from './ShipmentDetailsNotificationBanner.types'
